function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.80005 7.69961L10.5 9.09961M14 7.69961L14.7 5.59961M18.2 6.99961L18.9 8.39961",
  stroke: "#02BC4D",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.19995 11.1998V11.1998C4.19995 6.56061 7.96076 2.7998 12.5999 2.7998H15.4C20.0391 2.7998 23.8 6.56061 23.8 11.1998V11.1998",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.8 19.5996V19.5996C23.8 22.6924 21.2927 25.1996 18.2 25.1996H9.79996C6.70716 25.1996 4.19995 22.6924 4.19995 19.5996V19.5996",
  stroke: "#151515",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80005 12.9497C2.80005 11.9832 3.58355 11.1997 4.55005 11.1997H23.45C24.4165 11.1997 25.2 11.9832 25.2 12.9497V12.9497C25.2 13.9162 24.4165 14.6997 23.45 14.6997H4.55005C3.58355 14.6997 2.80005 13.9162 2.80005 12.9497V12.9497Z",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.80005 17.0576C2.80005 15.7554 3.85571 14.6997 5.15794 14.6997H22.8422C24.1445 14.6997 25.2001 15.7554 25.2001 17.0576V17.0576C25.2001 18.3598 24.1445 19.4155 22.8422 19.4155H5.15794C3.85571 19.4155 2.80005 18.3598 2.80005 17.0576V17.0576Z",
  stroke: "#02BC4D",
  strokeWidth: 2
});

var SvgBurger = function SvgBurger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/burger.ced6ccb2.svg";
export { ForwardRef as ReactComponent };